export const summaryPage = {
	heading: {
		sv: "Sammanställning av din beställning",
	},
	subHeading: {
		sv: "Här kan du se alla delar som ingår i din beställning. Kontrollera gärna att allt stämmer.",
	},
	waitForSignNotice: {
		sv: "Nu väntar vi på att dina kollegor ska signera avtalen som behövs.",
	},
	externalSignerInformation: {
		sv: "När du signerat kan huvudansökande {0} skicka in ansökan. Det är endast huvudansökande som kan skicka in.",
	},
	kycBoInvalid: {
		sv: "För att slutföra din ansökan behöver du ange verklig huvudman hos [Bolagsverket](https://bolagsverket.se/index.html). Banken får en uppdatering inom 24 timmar och du kan då slutföra din ansökan.",
	},
	guarantorSignText: {
		sv: "Alla personer nedan måste signera.",
	},
	creditLimit: {
		sv: "Kreditgräns {0}",
	},
	creditCard: {
		sv: "Kort {0} - ",
	},
};
